<template>

  <BilancioTable />
 
</template>

<script>
import BilancioTable from '../components/pratiche/BilancioFattureFornitori.vue'

export default {
  components: {
    BilancioTable

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>

